export default "__VITE_ASSET__chY0_3Yg__"